const languageObj = {
  "HitPaw Add Music to Audio Online": "HitPaw أضف الموسيقى إلى الصوت عبر الإنترنت",
  "Add BGM to Audio without any difficulties.": "أضف BGM إلى الصوت دون أي صعوبات.",
  "Add New": "اضف جديد",
  "Format": "صيغة",
  "Add tracks": "أضف المسارات",
};

export default languageObj